import TenantLogo from "components/TenantLogo";
import React from "react";
import { ScrollView, View } from "react-native";
import { useRsvpColors } from "../theme";

/**
 * Full-screen dark, centered card layout for the RSVP kiosk pages.
 * Intentionally renders no app chrome (no header/footer/nav) beyond the
 * tenant logo (light-background variant).
 */
const RsvpScaffold: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const colors = useRsvpColors();
  return (
    <View style={{ flex: 1, backgroundColor: colors.background }}>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
        }}
        keyboardShouldPersistTaps="handled"
      >
        <View style={{ width: "100%", maxWidth: 448 }}>
          <View style={{ alignItems: "center", marginBottom: 8 }}>
            <TenantLogo width={320} height={130} />
          </View>
          {children}
        </View>
      </ScrollView>
    </View>
  );
};

export default RsvpScaffold;
